import { ToastrService } from 'ngx-toastr';
import { catchError, map, of, take } from 'rxjs';
import { Inject, Injectable } from '@angular/core';

import { StorageHelper } from '@diktup/frontend/helpers';
import { CreateTargetOrderWithCartAndRegisterUserGQL } from '@sifca-monorepo/ecommerce-generator';
import { AppService } from '../app.service';
import { AuthService } from '../auth';

@Injectable()
export class CheckoutService {
  constructor(
    private appService: AppService,
    private authService: AuthService,
    private storageHelper: StorageHelper,
    protected toastrService: ToastrService,
    @Inject('ACCESS_TOKEN') private ACCESS_TOKEN: string,
    private createTargetOrderWithCartAndRegisterUserGql: CreateTargetOrderWithCartAndRegisterUserGQL,
  ) {}

  createTargetOrderWithCartAndRegisterUser(input) {
    return this.createTargetOrderWithCartAndRegisterUserGql
      .mutate({
        input: {
          ...input,
          target: {
            pos: this.storageHelper.getData('posId'),
          },
        },
      })
      .pipe(
        take(1),
        catchError(() => {
          this.toastrService.error('Something went wrong!');
          return of(null);
        }),
        map(({ data }) => {
          this.appService.isSignedIn = true;
          this.authService.authenticated$ = true;
          this.appService.clearCart();
          this.storageHelper.setData({ currentUserId: data.createTargetOrderWithCartAndRegisterUser.user.id });
          this.storageHelper.setData({ [this.ACCESS_TOKEN]: data.createTargetOrderWithCartAndRegisterUser.accessToken });
          return data.createTargetOrderWithCartAndRegisterUser;
        }),
      );
  }
}
